import { post } from '@/utils/examMan/request'
import request from "@/utils/request";

export function fetchTree() {
  // return post('/api/org/findTree', data)
  return request({
    url: `/org/findTree`,
    method: "get"
  });
}

export function fetchTreeSelect(data) {
  return post('/api/sys/depart/tree-select', data)
}

export function fetchDetail(id) {
  const data = { id: id }
  return post('/api/sys/depart/detail', data)
}

export function deleteData(ids) {
  const data = { ids: ids }
  return post('/api/sys/depart/delete', data)
}

export function saveData(data) {
  return post('/api/sys/depart/save', data)
}

export function sortData(id, sort) {
  const data = { id: id, sort: sort }
  return post('/api/sys/depart/sort', data)
}
